export default __webpack_public_path__ + "images/referenzen/werbespot/1822direkt.mp4";